<template>
  <b-collapse
    v-model="expanded"
    class="mb-2 ml-2 expanded-info"
  >
    <b-container
      fluid
      class="m-0 p-0"
    >
      <b-row class="m-2 p-0">
        <p
          v-if="type === 'add'"
          class="m-0 p-0 title-add"
        >
          Add Template
        </p>
        <p
          v-if="type === 'edit'"
          class="m-0 p-0 title-add"
        >
          Edit Template
        </p>
        <p
          v-if="type === 'import'"
          class="m-0 p-0 title-add"
        >
          Import Template
        </p>
      </b-row>
      <b-row
        v-if="isLoading"
        align-h="center"
        class="w-100"
      >
        <b-spinner
          variant="success"
          style="width: 2rem; height: 2rem;"
          label="Large Spinner Text Centered"
        />
      </b-row>
      <b-row
        v-else
        class="my-0 mx-1 p-0"
      >
        <b-col class="p-1 m-0">
          <b-form-input
            v-model="nameNewTempl"
            :state="nameNewTempl !== ''"
            aria-describedby="input-live-help input-live-feedback"
            placeholder="Enter the name"
            size="sm"
            class="add-template-input"
          />
          <b-form-invalid-feedback class="input-live-feedback">
            Please enter a valid name
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="p-1 m-0">
          <b-form-input
            v-model="typeNewTempl"
            placeholder="Enter the type"
            size="sm"
            class="add-template-input"
          />
        </b-col>
      </b-row>
      <b-row
        class="m-0 p-0"
        align-h="end"
      >
        <b-col cols="auto">
          <b-button
            size="sm"
            variant="primary"
            @click="execute"
          >
            Save
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button
            size="sm"
            variant="danger"
            @click="hideInput"
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </b-collapse>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'InputDataTemplate',
    props: {
        type: {
            type: String,
            required: true
        },
        elementid: {
            type: Number,
            required: true
        },
        data: {
            type: Array,
            required: true
        },
        iddict: {
            type: Object,
            required: true
        },
        importobj: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            nameNewTempl: '',
            typeNewTempl: '',
            expanded: false,
            isLoading: false
        }
    },
    computed: mapGetters(['getNameCurrProjectNavigation', 'getLastErrorMiddleware', 'getCurrentReportViewer', 'getCurrentClusterNavigation']),
    watch: {
        type(newVal) {
            if (newVal === 'add') { //Reset the values so the user can write from clean
                this.nameNewTempl = 'My new template'
                this.typeNewTempl = ''
            } else if (newVal === 'edit') { //Set the current values so the user can edit
                this.nameNewTempl = this.data[this.elementid][1]
                this.typeNewTempl = this.data[this.elementid][2]
            } else if (newVal === 'import') { //Reset the values so the user can write from clean
                this.nameNewTempl = 'My new template'
                this.typeNewTempl = ''
            }
            this.expanded = newVal !== ''
        }
    },
    methods: {
        ...mapActions(['addTemplateMiddlware', 'updateTemplateMiddlware', 'setUpdatedValueTemplatesReportViewer']),
        async execute() {
            this.isLoading = true
            try {
                if (this.type === 'add') { //Reset the values so the user can write from clean
                    const reportObjt = this.getCurrentReportViewer
                    const success = await this.addTemplateMiddlware({
                        clusterId: this.getCurrentClusterNavigation,
                        projectId: reportObjt.projectId,
                        name: this.nameNewTempl,
                        type: this.typeNewTempl,
                        source: reportObjt//Extraction a template from the report in the middleware
                    })
                    if (success) {
                        this.expanded = false
                        await this.$alert(
                            'Template added to ' + this.getNameCurrProjectNavigation,
                            'Success',
                            'success',
                        )
                        this.$emit('templateAdded')
                    } else {
                        const errText = 'Error sending the information to the server, please try in a few minutes. Error: ' + this.getLastErrorMiddleware
                        const errTitle = 'Error in Server'
                        const errZone = 'Input Data Template'
                        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, errZone)
                    }
                } if (this.type === 'import') { //Reset the values so the user can write from clean
                    const reportObjt = this.getCurrentReportViewer
                    const success = await this.addTemplateMiddlware({
                        clusterId: this.getCurrentClusterNavigation,
                        projectId: reportObjt.projectId,
                        name: this.nameNewTempl,
                        type: this.typeNewTempl,
                        source: this.importobj//Extraction a template from the report in the middleware
                    })
                    if (success) {
                        this.expanded = false
                        await this.$alert(
                            'Template imported to ' + this.getNameCurrProjectNavigation,
                            'Success',
                            'success',
                        )
                        this.$emit('templateImported')
                    } else {
                        const errText = 'Error sending the information to the server, please try in a few minutes. Error: ' + this.getLastErrorMiddleware
                        const errTitle = 'Error in Server'
                        const errZone = 'Input Data Template'
                        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, errZone)
                    }
                } else if (this.type === 'edit') { //Set the current values so the user can edit
                    const success = this.updateTemplateMiddlware({
                        clusterId: this.getCurrentClusterNavigation,
                        projectId: this.getCurrentReportViewer.projectId,
                        templateId: this.iddict[this.data[this.elementid][0]],
                        name: this.nameNewTempl,
                        type: this.typeNewTempl,
                    })
                    if (success) {
                        await this.$alert(
                            'Template updated',
                            'Success',
                            'success',
                        )
                        this.setUpdatedValueTemplatesReportViewer({
                            name: this.nameNewTempl,
                            type: this.typeNewTempl,
                            index: this.elementid
                        })
                        this.$emit('changeTemplates')
                    } else {
                        const errText = 'Error sending the information to the server, please try in a few minutes. Error: ' + this.getLastErrorMiddleware
                        const errTitle = 'Error in Server'
                        const errZone = 'Input Data Template'
                        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, errZone)
                    }
                }
            } catch (error) {

                const errText = 'Error sending the information to the server, please try in a few minutes.'
                const errTitle = 'Error in Server'
                const errZone = 'Input Data Template'
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, errZone)
            } finally {
                this.isLoading = false
            }
        },
        hideInput() {
            this.$emit('hideInput')
        }
    }
}
</script>

<style lang="scss" scoped>
.expanded-info {
    background-color: #DDD;
    border-radius: 5px;
    width: 85%;
}

.add-template-input {
    font-size: 0.8rem;
}

.title-add {
    font-weight: bold;
}
</style>
